import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import CompanyLocalitiesEditable from './CompanyLocalitiesEditable';
import messages from './messages/PaidFeatures_messages';

const propTypes = {
  editMode: PropTypes.bool.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  companyLocalities: PropTypes.array.isRequired,
  companyRegions: PropTypes.object.isRequired,
  localities: PropTypes.object,
  regions: PropTypes.object,
  locale: PropTypes.object.isRequired,
};

const CompanyLocalities = ({
  editMode,
  handleUpdate,
  locale,
  localities,
  companyLocalities,
  companyRegions,
  ...rest
}) => {

  const renderList = () => {
    const nameKey = locale.lang === 'en' ? 'name_fi' : `name_${locale.lang}`;
    return (
      companyLocalities
        .reduce((names, location) => {
          if (location) {
            const name = location[nameKey];
            names.push(name);
          }
          return names;
        }, [])
        .sort()
        .join(', ')
    );
  }

  return (
    <React.Fragment>
      <h2>
        <FormattedMessage
          {...messages.companyLocalities}
          info="Company municipalities"
        />
      </h2>
      {editMode
        ? (
          <CompanyLocalitiesEditable
            companyLocalities={companyLocalities}
            companyRegions={companyRegions}
            handleUpdate={handleUpdate}
            locale={locale}
            municipalities={localities}
            {...rest}
          />
        )
        : renderList()
      }
    </React.Fragment>
  );
};

CompanyLocalities.propTypes = propTypes;

export default CompanyLocalities;
